import { create } from "zustand";
import { juspayApi } from "@/services/api";
import { v4 as uuidv4 } from "uuid";
import { persist } from "zustand/middleware";

declare global {
  interface Window {
    Razorpay: any;
    HyperServices: any;
  }
}

interface JuspayStore {
  games: any[]; // adjust to correct type if known
  loading: boolean;
  error: any; // adjust type
  hyperServices: any; // you can refine this if you know the type of HyperServices
  juspaySdkPayload: any; // refine if known
  juspayUser: any;
  juspayId: any;
  juspayClientAuthToken: string | null;
  initiateJuspaySdk: (customerId: string) => Promise<any>;
  initializeJuspay: (user: any, useCache?: boolean) => Promise<any>;
  hyperCallbackHandler: (eventData: any) => void;
  toggleJustpayContainer: (isOpen: boolean) => void;
}

export const useJuspayStore = create<JuspayStore>()(
  // persist(
  (set, get) => ({
    games: [],
    loading: false,
    error: null,
    hyperServices: null,
    juspaySdkPayload: null,
    juspayUser: null,
    juspayId: null,
    juspayClientAuthToken: null,

    initiateJuspaySdk: async (customerId) => {
      try {
        const hyperServices = get().hyperServices;
        const juspaySdkPayload = {
          service: "in.juspay.hyperpay",
          requestId: uuidv4(),
          payload: {
            action: "initiate",
            clientId: "turftown",
            merchantId: "turftown",
            environment:
              process.env.NODE_ENV === "development" ? "sandbox" : "production",
            integrationType: "iframe",
            hyperSDKDiv: "juspay-container",
            customerId: customerId,
          },
        };
        if (!hyperServices && typeof window !== "undefined") {
          const hyper = new window.HyperServices({
            clientId: "turftown",
            merchantId: "turftown",
            environment:
              process.env.NODE_ENV === "development" ? "sandbox" : "production", // Use 'sandbox' for testing, 'production' for live
          });
          hyper.initiate(juspaySdkPayload, get().hyperCallbackHandler);
          set({
            hyperServices: hyper,
            juspaySdkPayload,
          });
          return Promise.resolve("Juspay store initiated");
        }
        return Promise.resolve("Juspay store already initiated");
      } catch (e) {
        console.error("initiateJuspaySdk error", e);
        return Promise.reject("initiateJuspaySdk error");
      }
    },

    initializeJuspay: async (user) => {
      try {
        let getJustpayCustomerResponse = await juspayApi.getJustpayCustomer(
          user.email as string
        );
        if (getJustpayCustomerResponse?.status !== "success") {
          //user is new
          getJustpayCustomerResponse = await juspayApi.createJuspayUser(user);
        }
        set({
          juspayUser: getJustpayCustomerResponse?.data,
        });
        const initiateResponse = await get().initiateJuspaySdk(
          getJustpayCustomerResponse?.data?.id
        );
        console.log(initiateResponse);
        set({
          juspayId: getJustpayCustomerResponse?.data.id,
          juspayClientAuthToken:
            getJustpayCustomerResponse?.data.juspay.client_auth_token,
        });
        return Promise.resolve(getJustpayCustomerResponse?.data.id);
      } catch (error) {
        console.error("initializeJuspay error", error);
        return Promise.reject("initializeJuspay error");
      }
    },
    hyperCallbackHandler(eventData: any) {
      try {
        if (eventData) {
          const eventJSON =
            typeof eventData === "string" ? JSON.parse(eventData) : eventData;
          const event = eventJSON.event;
          // Check for event key
          if (event == "initiate_result") {
            console.log("initiate_result", event);
            //Handle initiate result here
          } else if (event == "process_result") {
            //Handle process result here
            // if (eventData?.payload?.status === "backpressed") {
            //   unBlockSpot(
            //     paymentRedirectionData?.gameId,
            //     paymentRedirectionData?.payment_id
            //   );
            // }
            get().toggleJustpayContainer(false);
            // router.push(`${URLS.GAME_CART}/${paymentRedirectionData?.gameId}`);
          } else if (event == "user_event") {
            //Handle Payment Page events
          } else {
            console.log("Unhandled event", event, " Event data", eventData);
          }
        } else {
          console.log("No data received in event", eventData);
        }
      } catch (error) {
        console.log("Error in hyperSDK response", error);
      }
    },
    toggleJustpayContainer: (isOpen) => {
      const juspayContainer = document.getElementById("juspay-container");
      if (juspayContainer) {
        juspayContainer.style.display = isOpen ? "block" : "none";
      }
    },
  })
  //   {
  //     name: "juspay-store", // localStorage key
  //   }
  // )
);

// 🔥 Subscribe to store updates (Logs every state change)
useJuspayStore.subscribe((state) => {
  console.log("📢 Store Updated:", state);
});
